module.exports = __webpack_public_path__ + "static/capgemini-89f8aba98f9e263d25105d38161507ff.png";